<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 230px">
        <p>船舶名称：</p>
        <el-input v-model="shipIpt" size="mini" style="width: 150px" placeholder="请输入船舶名称" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>航次：</p>
        <el-input v-model="voyageIpt" size="mini" style="width: 150px" placeholder="请输入航次" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>船长姓名：</p>
        <el-input
          v-model="captainIpt"
          size="mini"
          style="width: 150px"
          placeholder="请输入船长姓名" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>出港港口：</p>
        <el-input
          v-model="sendportIpt"
          size="mini"
          style="width: 150px"
          placeholder="请输入出港港口" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>到港港口：</p>
        <el-input
          v-model="intodockIpt"
          size="mini"
          style="width: 150px"
          placeholder="请输入到港港口" />
      </div>
      <!-- <div class="navContainer" style="width: 400px">
        <p>发港时间：</p>
        <el-date-picker v-model="startTime" size="mini" style="width:150px" value-format="yyyy-MM-dd" @change="dateChange" type="date" placeholder="开始日期"/>
        <span style="display:inline-block;width:15px;text-align:center;font-size:18px">-</span>
        <el-date-picker v-model="endTime" size="mini" style="width:150px" value-format="yyyy-MM-dd" @change="dateChange" type="date" placeholder="结束日期"/>
      </div> -->
      <div class="navContainer" style="width: 320px">
        <p>预计到港时间：</p>
        <el-date-picker v-model="startTime" size="mini" style="width: 150px" value-format="yyyy-MM-dd HH:mm:ss" @change="dateChange1" type="date" placeholder="开始日期" />
        <span style="display: inline-block; width: 15px; text-align: center; font-size: 18px">-</span>
        <el-date-picker v-model="endTime" size="mini" style="width: 150px" value-format="yyyy-MM-dd HH:mm:ss" @change="dateChange1" type="date" placeholder="结束日期" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>状态：</p>
        <el-select
          v-model="stateIpt"
          filterable
          size="mini"
          style="width: 150px"
          placeholder="请选择状态">
          <el-option
            v-for="item in areaOption"
            :key="item.label"
            :label="item.label"
            :value="item.value" />
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">新增</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
          :header-cell-style="{
            color: '#3B3B3B',
            'font-size': '13px',
            height: '48px',
            background: '#E8E8E8',
          }"
          :cell-style="{ color: '#7F7F7F', 'font-size': '13px', height: '52px' }">
          <el-table-column label="序号" align="center" width="50px">
            <div slot-scope="scope">{{ scope.$index + 1 }}</div>
          </el-table-column>
          <el-table-column prop="shipName" label="船舶名称" align="center" />
          <el-table-column prop="voyageNumber" label="航次" align="center" />
          <el-table-column prop="shipmasterName" label="船长姓名" align="center" />
          <el-table-column prop="shipmasterPhone" label="船长电话" width="100" align="center" />
          <el-table-column prop="startPortName" label="出港码头" align="center" />
          <el-table-column prop="deliveryPortName" label="到港码头" align="center" />
          <el-table-column
            prop="startTime"
            label="预计出港日期"
            width="110"
            :formatter="getDate"
            align="center" />
          <el-table-column
            prop="endTime"
            label="预计到港日期"
            width="110"
            :formatter="getDate"
            align="center" />
          <el-table-column prop="handoverTime" label="航次结束时间" width="110" align="center" />
          <el-table-column label="状态" align="center">
            <div slot-scope="scope">{{ getState(scope.row.status) }}</div>
          </el-table-column>
          <el-table-column label="是否第三方" align="center">
            <div slot-scope="scope">{{ scope.row.thirdParty ? '是' : '否' }}</div>
          </el-table-column>
          <el-table-column label="实际供应商" align="center">
            <div slot-scope="scope">{{ scope.row.thirdPartySupplier }}</div>
          </el-table-column>
          <el-table-column label="操作" width="340" align="center">
            <template slot-scope="scope">
              <div style="align-items: center">
                <el-button
                  size="mini"
                  class="searchBtn"
                  type="primary"
                  @click="detailClick(scope.row.id)"
                  >详情
                </el-button>
                <el-button
                  v-if="scope.row.status != 2"
                  size="mini"
                  type="primary"
                  @click="changeClick(scope.row)"
                  class="yellow-bg"
                  >修改
                </el-button>
                <el-button
                  v-if="scope.row.status === 1"
                  size="mini"
                  type="primary"
                  @click="voyageClick(scope.row)"
                  >航次完成
                </el-button>
                <el-button
                  size="mini"
                  v-if="scope.row.status == 0"
                  type="danger"
                  @click="deleteClick(scope.row.id)"
                  >删除
                </el-button>
                <el-button
                  v-if="scope.row.status == 1 || scope.row.status == 2"
                  size="mini"
                  type="primary"
                  @click="onClickEditSupplier(scope.row)"
                  class="yellow-bg"
                  >修改供应商
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          :current-page="page"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange" />
      </div>
    </div>
    <el-dialog title="航次详情" :visible.sync="detailDialogVisible" width="610px" center>
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line" />
            <span>基础信息</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">船舶名称：</span>
              <span>{{ detailData.shipName }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">航次：</span>
              <span>{{ detailData.voyageNumber }}</span>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">船长姓名：</span>
                <span>{{ detailData.shipmasterName }}</span>
              </div>
              <div>
                <span class="span1">船长电话：</span>
                <span>{{ detailData.shipmasterPhone }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">出港码头：</span>
                <span>{{ detailData.startPortName }}</span>
              </div>
              <div>
                <span class="span1">到港码头：</span>
                <span>{{ detailData.deliveryPortName }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">预计出港日期：</span>
                <span>{{ getDate(0, 0, detailData.startTime) }}</span>
              </div>
              <div>
                <span class="span1">预计到港日期：</span>
                <span>{{ getDate(0, 0, detailData.endTime) }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">是否第三方：</span>
                <span>{{ detailData.thirdParty ? '是' : '否' }}</span>
              </div>
              <div v-if="detailData.thirdParty === 1">
                <span class="span1">实际供应商：</span>
                <span>{{ detailData.thirdPartySupplier }}</span>
              </div>
            </div>
            <!-- <div class="baseInfoContentItem">
              <span class="span1">是否翻坝：</span>
              <span>{{detailData.climbDam?'是':'否'}}</span>
              <span style="color: #999;font-size:13px;margin-left: 10px;" v-if="detailData.climbDam">{{detailData.damName}}</span>
            </div> -->
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line" />
            <span>操作信息</span>
          </div>
          <div class="operationTable">
            <el-table :data="operationData" border>
              <el-table-column label="操作时间" align="center" width="160px">
                <div slot-scope="scope">{{ getTime(scope.row.createTime) }}</div>
              </el-table-column>
              <el-table-column prop="operateType" label="操作类型" align="center" />
              <el-table-column prop="operationName" label="操作人" align="center" />
              <el-table-column prop="remark" label="备注" align="center" />
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="610px"
      center
      @close="dialogClose"
      :close-on-click-modal="false"
      top="10vh">
      <div class="company">
        <el-form :model="companyData" label-width="95px" :rules="rules" ref="ruleForm">
          <div-border label="船舶信息" prop="shipInfor">
            <el-form-item label="船舶名称：" prop="ship" style="margin-top: 15px">
              <el-select
                filterable
                v-if="dialogTitle != '修改航次'"
                v-model="companyData.ship"
                size="mini"
                style="width: 90%"
                placeholder="请选择船舶名称"
                value-key="id">
                <el-option
                  v-for="item in restaurants"
                  :key="item.id"
                  :label="item.name"
                  :value="item"
                  @click.native="voyageDataQuery(item.id)" />
              </el-select>
              <el-input
                v-if="dialogTitle == '修改航次'"
                disabled
                :style="'width:90%'"
                size="mini"
                v-model="companyData.ship.name" />
            </el-form-item>
            <el-form-item label="船长姓名：" prop="name">
              <el-input
                :style="'width:90%'"
                v-model="companyData.name"
                placeholder="请输入船长姓名"
                autocomplete="off"
                size="mini"
                :disabled="operationType" />
            </el-form-item>
            <el-form-item label="船长电话：" prop="tell" style="margin-bottom: 20px">
              <el-input
                :style="'width:90%'"
                v-model="companyData.tell"
                placeholder="请输入船长手机号"
                autocomplete="off"
                size="mini"
                :disabled="operationType" />
            </el-form-item>
            <el-form-item label="是否第三方：" prop="thirdParty" style="margin-bottom: 20px">
              <el-radio-group v-model="companyData.thirdParty" :disabled="operationType">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="实际供应商："
              prop="thirdPartySupplierId"
              v-if="companyData.thirdParty === 1"
              style="margin-top: 15px">
              <el-select
                filterable
                v-model="companyData.thirdPartySupplierId"
                size="mini"
                style="width: 90%"
                placeholder="请选择实际供应商"
                value-key="id"
                :disabled="operationType">
                <el-option
                  v-for="item in thirdPartySupplierOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id" />
              </el-select>
            </el-form-item>
          </div-border>
          <div-border label="港口信息" prop="port">
            <el-form-item label="起始港口：" prop="startPort" style="margin-top: 15px">
              <el-select
                filterable
                v-model="companyData.startPort"
                size="mini"
                style="width: 90%"
                placeholder="请选择起始港口名称"
                @change="handleSelect"
                value-key="id"
                :disabled="operationType">
                <el-option
                  v-for="item in startOption"
                  :key="item.id"
                  :label="item.supplier_name"
                  :value="item" />
              </el-select>
              <span
                v-if="companyData.startPort !== ''"
                style="color: #999; font-size: 12px; position: absolute; bottom: -25px; left: 0"
                >{{ companyData.startPort.address }}</span
              >
            </el-form-item>
            <el-form-item label="到达港口：" prop="endPort">
              <el-select
                filterable
                v-model="companyData.endPort"
                size="mini"
                style="width: 90%"
                placeholder="请选择到达港口名称"
                @change="handleSelect2"
                value-key="id">
                <el-option
                  v-for="item in startOption"
                  :key="item.id"
                  :label="item.supplier_name"
                  :value="item" />
              </el-select>
              <span
                v-if="companyData.endPort !== ''"
                style="color: #999; font-size: 12px; position: absolute; bottom: -25px; left: 0"
                >{{ companyData.endPort.address }}</span
              >
            </el-form-item>
            <el-form-item label="航次：" prop="voyage">
              <div
                style="
                  width: 100%;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                ">
                <el-input
                  :style="'width:80%'"
                  v-model="companyData.voyage"
                  placeholder="请输入航次"
                  autocomplete="off"
                  size="mini"
                  :disabled="voyageDisabled" />
                <el-checkbox v-model="voyageDisabled" :disabled="operationType">锁定</el-checkbox>
              </div>
            </el-form-item>
            <!-- <el-form-item label="是否翻坝：" prop="dam" style="margin-bottom: 20px">
              <div style="display:flex;align-items:center;height:40px;">
                <el-radio v-model="companyData.dam" :label="0">否</el-radio>
                <el-radio v-model="companyData.dam" :label="1">是</el-radio>
                <el-form-item v-if="companyData.dam===1" prop="damName" style="margin-bottom: 0">
                  <el-select v-model="companyData.damName" filterable size="mini" style="width:120px;" placeholder="请选择大坝" value-key="id">
                    <el-option v-for="item in damOption" :key="item.id" :label="item.attrNm" :value="item"/>
                  </el-select>
                </el-form-item>
              </div>
            </el-form-item> -->
          </div-border>
          <div-border label="时间信息" prop="time">
            <el-form-item
              label="预计出港日期："
              prop="enterTime"
              style="margin-top: 15px"
              label-width="120px">
              <el-date-picker
                size="mini"
                type="datetime"
                style="width: 90%"
                v-model="companyData.enterTime"
                format="yyyy-MM-dd HH"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择预计出港日期"
                @change="dateCalculation"
                :disabled="operationType" />
            </el-form-item>
            <el-form-item
              label="预计到港日期："
              prop="sendTime"
              style="margin-bottom: 20px"
              label-width="120px">
              <el-date-picker
                size="mini"
                type="datetime"
                style="width: 90%"
                v-model="companyData.sendTime"
                format="yyyy-MM-dd HH"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择到港日期"
                :disabled="operationType" />
            </el-form-item>
          </div-border>
          <div class="btnContainer">
            <el-button size="medium" class="searchBtn" :loading="addLoad" @click="addClick"
              >确认
            </el-button>
            <el-button size="medium" class="resetBtn" @click="dialogClose">关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <!-- 修改供应商弹窗 -->
    <el-dialog
      title="修改供应商"
      :visible.sync="supplierVisible"
      @close="supplierClose"
      center
      width="500px">
      <div class="p30 pb0">
        <!-- :rules="supplierRules" ref="supplierForm" -->
        <el-form
          :model="supplierData"
          label-width="100px"
          >
          <el-form-item label="供应商：" prop="port">
            <el-select
              v-model="supplierData.supplierId"
              class="w300"
              @change="handleChangeSupplierId"
              filterable
              clearable
              size="mini"
              value-key="id"
              placeholder="请选择供应商">
              <el-option
                v-for="item in thirdPartySupplierOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="supplierCloseDialog">取 消</el-button>
        <el-button size="mini" :loading="supplierSureLoad" type="primary" @click="supplierFinish"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import Vue from 'vue';
  import divBorder from '@/components/divBorder';
  import {
    dateCalculatio,
    voyageDataQuer,
    shipVoyageNumberPageList,
    shipVoyageNumberAdd,
    shipVoyageNumberDelete,
    shipVoyageNumberDetail,
    supplierPublicSelectPort,
    shipDocSelectShipByNotVoyage,
    voyageNumberGenerate,
    shipVoyageNumberUpdate,
    voyageFinish,
    updateSupplierHC,
  } from '@/service/vehiclelog';
  import { getParam } from '@/service/getData';
  import { formatDateTime } from '@/config/mUtils';
  import { highwayLineSelectWaterSupplier } from '@/service/financial';

  export default {
    components: {
      divBorder,
    },
    data() {
      const validateTell = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入船长手机号'));
        } else if (!/^[1][3,4,5,7,8,9][0-9]{9}$/.test(value)) {
          callback(new Error('请输入正确的手机号'));
        } else {
          callback();
        }
      };
      return {
        supplierVisible: false,
        supplierData: {
          supplierId: '',
        },
        nameOption: [],
        supplierSureLoad: false,
        activeRowId: '',  // 激活的id
        shipIpt: '',
        voyageIpt: '',
        captainIpt: '',
        sendportIpt: '',
        intodockIpt: '',
        startTime: '',
        endTime: '',
        // timeIpt:'',
        stateIpt: '',
        operationType: true,
        areaOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 0,
            label: '待出发',
          },
          {
            value: 1,
            label: '航行中',
          },
          {
            value: 2,
            label: '已完成',
          },
        ],
        page: 1,
        size: 10,
        total: 0,
        tableLoad: false,
        TableDatas: [],
        detailDialogVisible: false,
        detailData: {},
        operationData: [],
        dialogTitle: '',
        dialogVisible: false,
        voyageDisabled: true,
        addLoad: false,
        companyData: {
          enterTime: '',
          startPort: {},
          endPort: {},
          dam: 0,
          damName: '',
        },
        rules: {
          shipInfor: [
            {
              required: true,
              message: ' ',
              trigger: 'blur',
            },
          ],
          port: [
            {
              required: true,
              message: ' ',
              trigger: 'blur',
            },
          ],
          time: [
            {
              required: true,
              message: ' ',
              trigger: 'blur',
            },
          ],
          ship: [
            {
              required: true,
              message: '请输入船舶名称',
              trigger: 'blur',
            },
          ],
          voyage: [
            {
              required: true,
              message: '请输入航次',
              trigger: 'blur',
            },
          ],
          name: [
            {
              required: true,
              message: '请输入船长姓名',
              trigger: 'blur',
            },
          ],
          tell: [
            {
              required: true,
              validator: validateTell,
              trigger: 'blur',
            },
          ],
          startPort: [
            {
              required: true,
              message: '请输入起始港口',
              trigger: 'blur',
            },
          ],
          endPort: [
            {
              required: true,
              message: '请输入到达港口',
              trigger: 'blur',
            },
          ],
          enterTime: [
            {
              required: true,
              message: '请选择进港时间',
              trigger: 'change',
            },
          ],
          sendTime: [
            {
              required: true,
              message: '请输入出航时间',
              trigger: 'change',
            },
          ],
          dam: [
            {
              required: true,
              message: '请选择是否翻坝',
              trigger: 'change',
            },
          ],
          damName: [
            {
              required: true,
              message: '请选择大坝名称',
              trigger: 'change',
            },
          ],
          thirdParty: [
            {
              required: true,
              message: '请选择是否第三方',
              trigger: 'blur',
            },
          ],
          thirdPartySupplierId: [
            {
              required: true,
              message: '请选择实际供应商',
              trigger: 'blur',
            },
          ],
        },
        restaurants: [],
        startOption: [],
        damOption: [],
        thirdPartySupplierOptions: [],
      };
    },
    computed: {
      getState() {
        return function (state) {
          switch (state) {
            case 0:
              return '待出发';
            case 1:
              return '航行中';
            case 2:
              return '已完成';
          }
        };
      },
      getTime() {
        return function (time) {
          return formatDateTime(time, 'yyyy-mm-dd hh:ii:ss');
        };
      },
    },
    mounted() {
      this.init();
      this.getThirdPartySupplier();
    },
    methods: {
      supplierClose() {},
      handleChangeSupplierId() {},
      supplierCloseDialog() {
        this.supplierVisible = false;
      },
      async supplierFinish() {
        this.supplierSureLoad = true;
        // console.log(this.activeRowId);
        // console.log(this.supplierData.supplierId);
        const res = await updateSupplierHC({id: this.activeRowId, supplierId: this.supplierData.supplierId})
        // console.log(res);
        setTimeout(() => {
          if (res.status != 0) {
            this.$message.error(res.message);
          } else {
            this.$message.success(res.message);
            this.searchBtn()
            this.supplierVisible = false;
          }
          this.supplierSureLoad = false;
        }, 1000);

      },
      async getThirdPartySupplier() {
        const { status, message, data } = await highwayLineSelectWaterSupplier();
        if (status !== 0) return this.$message.warning(message);
        this.thirdPartySupplierOptions = data;
      },
      async init() {
        // await this._shipVoyageNumberPageList();
        const res = await supplierPublicSelectPort();
        if (res.status !== 0) {
          this.$message.error(res.message);
        } else {
          this.startOption = res.data;
        }
        console.log(111, this.startOption);
      },
      async _shipVoyageNumberPageList() {
        this.tableLoad = true;
        const res = await shipVoyageNumberPageList({
          shipName: this.shipIpt,
          shipmasterName: this.captainIpt,
          voyageNumber: this.voyageIpt,
          // leavePortName:this.sendportIpt,
          startPortName: this.sendportIpt,
          // arrivalPortName:this.intodockIpt,
          deliveryPortName: this.intodockIpt,
          startTime:this.startTime,
          endTime:this.endTime,
          status: this.stateIpt,
          rows: this.size,
          page: this.page,
        });
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.TableDatas = res.data.records;
        this.total = res.data.total;
      },
      // 结束时间
      dateChange(val) {
        if (this.endTime && this.startTime && this.endTime <= this.startTime) {
          if (val == this.endTime) this.endTime = '';
          if (val == this.startTime) this.startTime = '';
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },
      bjDate(date, date1) {
        var date = new Date(date);
        var date1 = new Date(date1);
        // 减小于0 date<date1
        return date.getTime() - date1.getTime() < 0;
      },
      async handleSelect(item) {
        if (!this.companyData.ship.id) {
          this.companyData.startPort = {};
          return this.$message.error('请先选择船舶！');
        }
        if (this.companyData.endPort && this.companyData.endPort.id === item.id) {
          this.companyData.startPort = {};
          return this.$message.warning('起始港口与到达港口不能相同！');
        }
        this.companyData.startPort = item;
        if (
          (this.companyData.endPort.coordinate && this.companyData.voyage === '') ||
          !this.voyageDisabled
        ) {
          if (
            !item.coordinate ||
            item.coordinate == '' ||
            !this.companyData.endPort.coordinate ||
            this.companyData.endPort.coordinate == ''
          ) {
            return false;
          }
          const res = await voyageNumberGenerate({
            shipId: this.companyData.ship.id,
            leaveLongitude: item.coordinate,
            arrivalLongitude: this.companyData.endPort.coordinate,
          });
          if (res.status !== 0) return this.$message.error(res.message);
          this.companyData.voyage = res.data.voyageNumber;
        }
      },
      async handleSelect2(item) {
        if (!this.companyData.ship.id) {
          this.companyData.endPort = {};
          return this.$message.error('请先选择船舶！');
        }
        if (this.companyData.startPort && this.companyData.startPort.id === item.id) {
          this.companyData.endPort = {};
          return this.$message.warning('起始港口与到达港口不能相同！');
        }
        this.companyData.endPort = item;
        if (
          (this.companyData.startPort.coordinate && this.companyData.voyage === '') ||
          !this.voyageDisabled
        ) {
          if (
            !item.coordinate ||
            item.coordinate == '' ||
            !this.companyData.startPort.coordinate ||
            this.companyData.startPort.coordinate == ''
          ) {
            return false;
          }
          const res = await voyageNumberGenerate({
            leaveLongitude: item.coordinate.split(',')[0],
            arrivalLongitude: this.companyData.startPort.coordinate.split(',')[0],
            shipId: this.companyData.ship.id,
          });
          if (res.status !== 0) return this.$message.error(res.message);
          this.companyData.voyage = res.data.voyageNumber;
        }
      },
      contractSizeChange(sizes) {
        this.size = sizes;
        this._shipVoyageNumberPageList();
      },
      contractCurrentChange(page) {
        this.page = page;
        this._shipVoyageNumberPageList();
      },
      async detailClick(id) {
        this.detailDialogVisible = true;
        const res = await shipVoyageNumberDetail(id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.detailData = res.data;
        this.operationData = res.data.operateRecordList;
      },
      async voyageDataQuery(id) {
        const res = await voyageDataQuer(id);
        if (res.data != null) {
          this.companyData.name = res.data.captainName;
          this.companyData.tell = res.data.captainTel;
        } else {
          this.companyData.name = '';
          this.companyData.tell = '';
        }
      },
      async dateCalculation() {
        // debugger;
        // if(this.companyData.enterTime>this.companyData.sendTime){
        //   return this.$message.warning("开始日期，不能大于结束日期");
        // }else
        if (this.companyData.startPort.id == undefined) {
          return this.$message.warning('启运港不能为空！');
        } else if (this.companyData.endPort.id == undefined) {
          return this.$message.warning('到达港不能为空！');
        }
        let data = {
          departurePortId: this.companyData.startPort.id,
          arrivePortId: this.companyData.endPort.id,
        };
        const res = await dateCalculatio(data);
        if (res.data != null) {
          //计算日期
          var dateItem = new Date(this.companyData.enterTime); //使用当天时间戳减去以前的时间毫秒（小时*分*秒*毫秒）
          if (res.data.timeUnit == '时') {
            //时间相加
            let startDay =
              dateItem.getFullYear() +
              '-' +
              (dateItem.getMonth() + 1).toString().padStart(2, '0') +
              '-' +
              dateItem.getDate().toString().padStart(2, '0') +
              ' ' +
              (dateItem.getHours() + res.data.estimateTime).toString().padStart(2, '0') +
              ':' +
              dateItem.getMinutes().toString().padStart(2, '0') +
              ':' +
              dateItem.getSeconds().toString().padStart(2, '0');
            this.companyData.sendTime = startDay;
          } else {
            let number = '';
            if (res.data.timeUnit == '天') {
              number = res.data.estimateTime;
            } else if (res.data.timeUnit == '周') {
              //周转换为天数
              number = res.data.estimateTime * 7;
            }
            let startDay =
              dateItem.getFullYear() +
              '-' +
              (dateItem.getMonth() + 1).toString().padStart(2, '0') +
              '-' +
              (dateItem.getDate() + number).toString().padStart(2, '0') +
              ' ' +
              dateItem.getHours().toString().padStart(2, '0') +
              ':' +
              dateItem.getMinutes().toString().padStart(2, '0') +
              ':' +
              dateItem.getSeconds().toString().padStart(2, '0');
            this.companyData.sendTime = startDay;
          }
        } else {
          this.companyData.sendTime = '';
        }
      },
      onClickEditSupplier(row) {
        console.log(row);
        this.supplierData.supplierId = row.supplierId;
        this.activeRowId = row.id;
        this.supplierVisible = true;
      },
      // 修改
      async changeClick(item) {
        this.voyageDisabled = true;
        console.log(item);
        this.companyData = {
          ...item,
          ship: {
            name: item.shipName,
            id: item.shipId,
          },
          voyage: item.voyageNumber,
          name: item.shipmasterName,
          tell: item.shipmasterPhone,
          startPort: {
            // id:item.leavePortId,
            // supplier_name:item.leavePortName,
            // longitude:Number(item.leavePortLongitude),
            // address:item.leavePortAddr,
            id: item.startPortId,
            supplier_name: item.startPortName,
            longitude: Number(item.startCoordinate),
            address: item.startName,
          },
          endPort: {
            // id:item.arrivalPortId,
            // supplier_name:item.arrivalPortName,
            // longitude:Number(item.arrivalPortLongitude),
            // address:item.arrivalPortAddr,
            id: item.deliveryPortId,
            supplier_name: item.deliveryPortName,
            longitude: Number(item.deliveryCoordinate),
            address: item.deliveryName,
          },
          enterTime: item.startTime,
          sendTime: item.endTime,
          dam: item.climbDam,
          damName: {
            id: item.damId,
            attrNm: item.damName,
          },
          thirdParty: Number(item.thirdParty),
          thirdPartySupplierId: item.thirdPartySupplierId,
        };
        item.status === 0 ? (this.operationType = false) : (this.operationType = true);
        this.dialogTitle = '修改航次';
        this.dialogVisible = true;
        const res3 = await getParam({ categoryCd: 'voyage_dam' });
        if (res3.status !== 0) {
          this.$message.error(res3.message);
        } else {
          this.damOption = res3.data.map(item => {
            return {
              attrNm: item.classaName,
              id: item.id,
            };
          });
        }
      },
      // 航次完成
      async voyageClick(row) {
        let handoverTime = row.handoverTime || '';
        const h = this.$createElement;
        await this.$msgbox({
          title: '提示',
          message: h(
            Vue.component('messagebox-date-picker', {
              data() {
                return {
                  value: handoverTime,
                };
              },
              render() {
                const h = this.$createElement;
                return h('div', { style: { 'text-align': 'center' } }, [
                  '实际完成时间：',
                  h('el-date-picker', {
                    props: { value: this.value },
                    on: {
                      input: val => {
                        console.log(val);
                        this.value = handoverTime = val;
                      },
                    },
                    attrs: {
                      size: 'mini',
                      valueFormat: 'yyyy-MM-dd',
                      type: 'date',
                      disabled: !!row.handoverTimeFlag,
                    },
                  }),
                ]);
              },
            }),
          ),
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = '提交中...';
              if (!handoverTime) {
                instance.confirmButtonLoading = false;
                instance.confirmButtonText = '确定';
                return this.$message.warning('请选择实际完成时间后提交！');
              }
              let res = await voyageFinish({
                id: row.id,
                handoverTime,
              });
              if (res.status !== 0) {
                instance.confirmButtonLoading = false;
                instance.confirmButtonText = '确定';
                return this.$message.warning(res.message);
              }
              this.$message.success(res.message);
              await this._shipVoyageNumberPageList();
              done();
            } else {
              done();
            }
          },
        });
      },
      // 预计到港时间开始-结束日期验证
      dateChange1(val) {
        if (this.endTime && this.startTime && this.endTime <= this.startTime) {
          if (val == this.endTime) this.endTime = '';
          if (val == this.startTime) this.startTime = '';
          this.$forceUpdate();
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },
      searchBtn() {
        this.page = 1;
        this._shipVoyageNumberPageList();
      },
      resetBtn() {
        this.shipIpt = '';
        this.voyageIpt = '';
        this.captainIpt = '';
        this.sendportIpt = '';
        this.intodockIpt = '';
        // this.timeIpt=''
        this.startTime = '';
        this.endTime = '';
        this.stateIpt = '';
      },
      async addBtn() {
        this.dialogTitle = '添加航次';
        this.dialogVisible = true;
        this.voyageDisabled = true;
        this.operationType = false;
        this.companyData = {
          ship: '',
          voyage: '',
          name: '',
          tell: '',
          startPort: {},
          endPort: {},
          enterTime: '',
          sendTime: '',
          dam: 0,
          damName: '',
          thirdParty: '',
          thirdPartySupplierId: '',
        };
        const res = await shipDocSelectShipByNotVoyage();
        if (res.status !== 0) {
          this.$message.error(res.message);
        } else {
          this.restaurants = res.data;
        }
        const res3 = await getParam({ categoryCd: 'voyage_dam' });
        if (res3.status !== 0) {
          this.$message.error(res3.message);
        } else {
          this.damOption = res3.data.map(item => {
            return {
              attrNm: item.classaName,
              id: item.id,
            };
          });
        }
      },
      addClick() {
        this.$refs.ruleForm.validate(async valid => {
          if (valid) {
            if (!this.bjDate(this.companyData.enterTime, this.companyData.sendTime))
              return this.$message.warning('结束时间不得小于开始时间！');
            this.addLoad = true;
            const obj = {
              id: this.companyData.id,
              shipId: this.companyData.ship.id,
              shipName: this.companyData.ship.name,
              shipmasterName: this.companyData.name,
              shipmasterPhone: this.companyData.tell,
              voyageNumber: this.companyData.voyage,
              // leavePortId:this.companyData.startPort.id,
              startPortId: this.companyData.startPort.id,
              leavePortName: this.companyData.startPort.supplier_name,
              leavePortLongitude: this.companyData.startPort.coordinate,
              leavePortAddr: this.companyData.startPort.address,
              // arrivalPortId:this.companyData.endPort.id,
              deliveryPortId: this.companyData.endPort.id,
              arrivalPortName: this.companyData.endPort.supplier_name,
              arrivalPortLongitude: this.companyData.endPort.coordinate,
              arrivalPortAddr: this.companyData.endPort.address,
              // climbDam:this.companyData.dam,  // 是否翻坝
              damId: this.companyData.dam ? this.companyData.damName.id : '',
              damName: this.companyData.dam ? this.companyData.damName.attrNm : '',
              startTime: this.companyData.enterTime,
              endTime: this.companyData.sendTime,
              thirdParty: this.companyData.thirdParty,
              thirdPartySupplierId: this.companyData.thirdPartySupplierId,
            };
            const res =
              this.dialogTitle === '添加航次'
                ? await shipVoyageNumberAdd(obj)
                : await shipVoyageNumberUpdate(obj);
            this.addLoad = false;
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._shipVoyageNumberPageList();
            this.dialogVisible = false;
          } else {
            return false;
          }
        });
      },
      dialogClose() {
        this.dialogVisible = false;
        this.companyData = {
          startPort: '',
          endPort: '',
          start: {
            value: '',
            key: '',
            address: '',
            label: '',
          },
          end: {
            value: '',
            key: '',
            address: '',
            label: '',
          },
          ship: {
            name: '',
            id: '',
          },
          fullName: '',
          referred: '',
          tell: '',
          area: '',
          address: '',
          name: '',
          nameTell: '',
        };
        this.$refs.ruleForm.resetFields();
      },
      deleteClick(id) {
        this.$confirm('确定要删除当前航次吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await shipVoyageNumberDelete(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.page = 1;
            await this._shipVoyageNumberPageList();
          })
          .catch(() => {});
      },
      // 出港码头
      // startPort(row) {
      //   if(row.startName && row.startPortName) {
      //     return row.startName+'【'+row.startPortName+'】';
      //   }else if(row.startName && !row.startPortName) {
      //     return row.startName;
      //   }else if(!row.startName && row.startPortName) {
      //     return '【'+row.startPortName+'】';
      //   }
      // },
      // 进港码头
      // endPort(row) {
      //   if(row.deliveryName && row.deliveryPortName) {
      //     return row.deliveryName+'【'+row.deliveryPortName+'】';
      //   }else if(row.deliveryName && !row.deliveryPortName) {
      //     return row.deliveryName;
      //   }else if(!row.deliveryName && row.deliveryPortName) {
      //     return '【'+row.deliveryPortName+'】';
      //   }
      // },
      // 获取时间年月日
      getDate(row, elem, column) {
        if (typeof column == 'string') {
          return column.substring(0, 13);
        } else {
          return '';
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;
    background-color: #fff;

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .navContainer p {
        display: inline-block;
        width: 80px;
        text-align: right;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
        margin-left: 10px;
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainer {
        margin-top: 30px;
        margin-bottom: 25px;
        width: 100%;

        ::v-deep {
          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          &Item {
            margin-bottom: 20px;

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table td,
          .el-table th {
            padding: 0;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }

    .company {
      width: 100%;
      padding: 20px 10px;

      ::v-deep {
        .el-form-item__label {
          font-weight: 700;
        }

        .el-form-item__label {
          padding: 0;
        }

        .el-form-item__content {
          position: relative;
        }

        .el-form-item {
          margin-bottom: 13px;
        }
      }

      hr {
        margin: 0;
        position: absolute;
        width: 100%;
        bottom: 5px;
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-table th > .cell {
        font-weight: 700 !important;
      }
    }
  }

  ::v-deep {
    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #ffffff;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
      max-height: 500px;
      overflow-y: auto;
    }
  }
</style>
